/* eslint-disable */
import React, { useRef } from 'react';
import './_file.button.scss'
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import Spinner from '../Loaders/Spinner';

const FileButton = ({ name, isLoading, multiple, accept, onChange }) => {
  const inputRef = useRef(null);

  const onUploadFile = () => {
    if (!isLoading) {
      inputRef.current.click();
    }
  }

  const onChangeUploadFile = (e) => {
    onChange(e);
    inputRef.current.value = '';
  }

  return (
    <div className="file-button">
      <input
        multiple={multiple ? 'multiple' : null}
        className="file-button__input"
        type="file"
        ref={inputRef}
        onChange={onChangeUploadFile}
        accept={accept.map(item => `.${item}`).join(', ')}
      />
      <Button onClick={onUploadFile} disabled={isLoading} block>
        {isLoading ? <Spinner /> : null }
        {name}
      </Button>
    </div>
  )
}

FileButton.defaultProps = {
  name: "Upload",
  accept: ['png', 'jpg', 'jpeg']
}

FileButton.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func,
  isLoading: PropTypes.bool,
  multiple: PropTypes.bool,
  accept: PropTypes.array,
}

export default FileButton;
